// Which payment options the checkout shows, from GET /payments/methods ({ upi, card }).
// Both are paid in Razorpay Checkout; the value is also what POST /payments/razorpay/create-order expects (uppercased).
export const METHOD_UPI = 'upi'
export const METHOD_CARD = 'card'

export const enabledMethods = (methods) => {
    if (!methods) return []
    return [METHOD_UPI, METHOD_CARD].filter(m => methods[m] === true)
}

// Preselect when there is a single option; on mobile UPI (Google Pay, PhonePe…) is the natural first choice.
export const defaultMethod = (enabled, isMobile) => {
    if (enabled.length === 1) return enabled[0]
    if (isMobile && enabled.includes(METHOD_UPI)) return METHOD_UPI
    return null
}

// Phones and tablets, where Razorpay's UPI option opens the UPI apps directly (desktop shows a QR code)
export const isMobileDevice = () => {
    const ua = navigator.userAgent || ''
    // iPadOS 13+ reports itself as a Mac; touch support gives it away
    return /Android|iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}
